import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chatflow',
  templateUrl: './chatflow.component.html',
  styleUrls: ['./chatflow.component.scss']
})
export class ChatflowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
